import { Metadata, EntityDescription, TypeDescriptionService } from '../Api/interfaces';
import AuthenticatedDescriptionService from './AuthenticatedDescriptionService';
import DummyTypeService from './DummyTypeService';
import AuthenticationService from './AuthenticationService'
export default class DescriptionService implements TypeDescriptionService {

  getDescriptor(typeName: string): Promise<EntityDescription> {
    return this.getService().getDescriptor(typeName);
  }

  private getService(): TypeDescriptionService {
    const header = AuthenticationService.getSessionInfo();
    return (header) ? AuthenticatedDescriptionService.getInstance() : DummyTypeService.getInstance();
  }



  getDescriptors(): Promise<EntityDescription[]> {
    return this.getService().getDescriptors();
  }

  getMetadata(): Promise<Metadata> {
    return this.getService().getMetadata();
  }
}
